import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { Spacing } from '../../style'

import Button, { Props as ButtonProps } from './button'

const Size = 60

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    right: Spacing.S,
    bottom: Spacing.S,
  },
  buttonContent: {
    width: Size,
    height: Size,
    borderRadius: 30,
  },
})

export interface Props extends Omit<ButtonProps, 'style'> {
  style?: StyleProp<ViewStyle>
}
const FloatingButton = (props: Props) => {
  const { right, bottom } = useSafeAreaInsets()
  const style = {
    marginRight: right,
    marginBottom: bottom,
  }
  return <Button style={[styles.button, style]} contentContainerStyle={styles.buttonContent} {...props} />
}

export default FloatingButton
